<template>
  <v-tooltip left dark color="black">
    <template v-slot:activator="{ on, attrs }">
      <span
        :class="`h-[75px] w-[75px]  p-1 ${routeLink}_btn_color rounded-full relative test_animate `"
      >
        <v-badge
          v-if="badge"
          overlap
          left
          bordered
          :icon="!badgeContentComputed ? 'mdi-crown-outline' : ''"
          :value="badgeContentComputed"
          :content="badgeContentComputed"
          :color="colorAsRoute"
          avatar
          dark
          color="black"
          :class="` font-Nunito ${routeLink}_text_color `"
          offset-x="15"
          offset-y="15"
        >
          <v-btn
            fab
            width="66"
            height="66"
            :color="`${routeLink}_btn_bg`"
            dark
            class=""
            :to="link"
            elevation="0"
            v-bind="attrs"
            v-on="on"
            @click.prevent="$emit('callFunction')"
          >
            <Icon
              :class="`${iconSize ? iconSize : 'text-4xl'}   font-semibold`"
              :color="routeLink == 'gay' ? 'white' : 'black'"
              :icon="iconName"
            />
          </v-btn>
        </v-badge>
        <v-btn
          v-else
          fab
          width="66"
          height="66"
          :color="`${routeLink}_btn_bg`"
          dark
          :to="link"
          class=" "
          elevation="0"
          v-bind="attrs"
          v-on="on"
          @click.prevent="$emit('callFunction')"
        >
          <Icon
            :class="`${iconSize ? iconSize : 'text-4xl'} font-semibold`"
            :color="routeLink == 'gay' ? 'white' : 'black'"
            :icon="iconName"
          />
        </v-btn>
      </span>
    </template>
    <span :class="`${routeLink}_text_color`">{{ name }}</span>
  </v-tooltip>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon,
  },
  props: {
    iconSize: String,
    iconName: String,
    name: String,
    badge: Boolean,
    link: Object,
    badgeContent: String,
  },
  computed: {
    badgeContentComputed() {
      if (this.badgeContent == "notification") {
        return this.$store.getters.unreadNotification;
      } else if (this.badgeContent == "message") {
        return this.$store.getters.unreadMessages;
      }
    },
    premium() {
      return this.$store.getters.isPremium;
    },
    colorAsRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      } else if (this.routeLink == "gay") {
        return "#88c3fa";
      } else if (this.routeLink == "lesbian") {
        return "#9e2eec";
      }
    },
    colorAsNavRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      } else if (this.routeLink == "gay") {
        return "#0063a2";
      } else if (this.routeLink == "lesbian") {
        return "#7db1f5";
      }
    },
  },
};
</script>
<style scoped>
.test_animate:hover {
  background-position: right center !important;
  background-size: 200% auto !important;
  transition: all 0.3s ease-in-out !important;
}

.gay_btn_color {
  background: rgb(0, 16, 245);
  background: -moz-linear-gradient(
    208deg,
    rgb(30 0 217) 40%,
    rgb(3 90 255) 60%,
    rgba(0, 147, 243, 1) 100%
  );
  background: -webkit-linear-gradient(
    208deg,
    rgb(30 0 217) 40%,
    rgb(3 90 255) 60%,
    rgba(0, 147, 243, 1) 100%
  );
  background: linear-gradient(
    208deg,
    rgb(30 0 217) 40%,
    rgb(3 90 255) 60%,
    rgba(0, 147, 243, 1) 100%
  );
}

.lesbian_btn_color {
  background: #8701b9;
  /* background: -moz-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
    background: -webkit-linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%);
    background: linear-gradient(208deg, rgb(30 0 217) 40%, rgb(3 90 255) 60%, rgba(0, 147, 243, 1) 100%); */
}

.straight_btn_color {
  background: rgb(228, 192, 104);

  background: linear-gradient(
    83deg,
    rgba(228, 192, 104, 1) 0%,
    rgba(167, 132, 40, 1) 22%,
    rgba(202, 174, 113, 1) 55%,
    rgba(166, 133, 43, 1) 85%
  );
}

.straight_btn_bg {
  background: rgb(228, 192, 104);

  background: linear-gradient(
    135deg,
    rgba(228, 192, 104, 1) 7%,
    rgb(182 149 61) 33%,
    rgba(202, 174, 113, 1) 55%,
    rgba(166, 133, 43, 1) 80%
  );
}

.gay_btn_bg {
  background-color: #0063a2 !important;
}

.lesbian_btn_bg {
  background: rgb(122, 174, 245);
  background: -moz-linear-gradient(
    133deg,
    rgba(122, 174, 245, 1) 25%,
    rgba(172, 208, 244, 1) 50%,
    rgba(122, 188, 244, 1) 75%
  );
  background: -webkit-linear-gradient(
    133deg,
    rgba(122, 174, 245, 1) 25%,
    rgba(172, 208, 244, 1) 50%,
    rgba(122, 188, 244, 1) 75%
  );
  background: linear-gradient(
    133deg,
    rgba(122, 174, 245, 1) 25%,
    rgba(172, 208, 244, 1) 50%,
    rgba(122, 188, 244, 1) 75%
  );
}

.straight_text_color {
  color: #a07a1d !important;
}

.gay_text_color {
  color: #88c3fa !important;
}

.lesbian_text_color {
  color: #9e2eec !important;
}

.straight_text_color:deep(.v-badge__badge) {
  color: #a07a1d !important;
}

.gay_text_color:deep(.v-badge__badge) {
  color: #88c3fa !important;
}

.lesbian_text_color:deep(.v-badge__badge) {
  color: #9e2eec !important;
}
</style>
